<article class="presentation-tab">
  <section
    class="presentation-tab__body presentation-tab-body"
    [innerHtml]="tabContent"
    (appMutationObserver)="secureExternalLinks($event)"
  ></section>

  <company-other-info class="presentation-tab__others"></company-other-info>
</article>
